import { Extension } from "@tiptap/core";

const ALIGNMENTS = [
  "ql-align-center",
  "ql-align-right",
  "ql-align-justify",
];

export const TextAlign = Extension.create({
  name: "textAlign",

  addOptions() {
    return {
      types: ["heading", "listItem", "taskItem", "paragraph"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: null,
            parseHTML: (element) => {
              for (let i = 0; i < element.classList.length; i++) {
                const className = element.classList[i];
                if (ALIGNMENTS.includes(className)) {
                  return className;
                }
              }
              return null;
            },
            renderHTML: (attributes) => {
              return attributes.textAlign ? { class: attributes.textAlign } : {};
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setTextAlign: (alignment) => ({ commands }) => {
        return this.options.types
          .map((type) => commands.updateAttributes(type, { textAlign: alignment }))
          .every((response) => response);
      },
      unsetTextAlign: () => ({ commands }) => {
        return this.options.types
          .map((type) => commands.resetAttributes(type, "textAlign"))
          .every((response) => response);
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.unsetTextAlign(),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify"),
      // Shift+Enter has to be added explicitly to work
      "Mod-Enter": () => this.editor.commands.enter(),
      "Shift-Enter": () => this.editor.commands.enter(),
    };
  },
});
